<template>
    <base-dialog :value="dialog" :width="560" :title="$t('exercises.watch_video')" @input="onInput" @close="hide">
        <div v-if="video" class="video-wrap">
            <youtube-iframe v-if="isYoutubeVideo" :link="youtubeUrl" height="100%" />
            <video-player v-else-if="dialog || closing" ref="videoPlayer" :options="playerOptions" />
            <loading-spinner v-else class="video-loading" height="100%" no-margin-top />
        </div>
        <div v-if="commentary" class="video-comment">
            <b>{{ $t('exercises.comment_of_coach') }}:</b> {{ commentary }}
        </div>
    </base-dialog>
</template>

<script>

import BaseDialog from "@/components/common/BaseDialog";
import VideoPlayer from '@/components/common/VideoPlayer'
import YoutubeIframe from '../YoutubeIframe.vue';
import LoadingSpinner from '../LoadingSpinner.vue';

const HLS_TYPE = 'application/x-mpegURL'

export default {
    props: {
        video: {
            type: String,
            default: null,
        },
        thumb: {
            type: String,
            default: require(`@/assets/img/brand_mark.png`)
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        local: {
            type: Boolean,
            default: false,
        },
        commentary: {
            type: String,
            default: null,
        },
    },
    components: {
        BaseDialog,
        VideoPlayer,
        YoutubeIframe,
        LoadingSpinner,
    },
    data() {
        return {
            dialog: false,
            playerOptions: {
                fluid: false,
                language: 'es',
                controls: true,
                autoplay: false,
                poster: null,
                sources: [{
                    type: HLS_TYPE,
                    src: null,
                }],
            },
            isYoutubeVideo: false,
            youtubeUrl: null,
            closing: false,
            closeTimer: null,
        }
    },
    computed: {
        videoType(vm = this) {
            const match = String(vm.video || '').match(/\.(mp4|webm|mov|m4v)(\?|$)/i)
            if (!match) return HLS_TYPE
            const extension = match[1].toLowerCase()
            return extension === 'webm' ? 'video/webm' : 'video/mp4'
        },
    },
    methods: {
        show(isYoutubeVideo) {
            const vm = this
            if (vm.closeTimer) { clearTimeout(vm.closeTimer); vm.closeTimer = null }
            vm.closing = false
            vm.isYoutubeVideo = isYoutubeVideo
            vm.dialog = true
            vm.loadVideo()
        },
        hide() {
            const vm = this
            if (!vm.dialog) return
            vm.dialog = false
            vm.closing = true
            if (vm.$refs.videoPlayer && vm.$refs.videoPlayer.player) vm.$refs.videoPlayer.player.pause()
            vm.$emit('hide')
            vm.closeTimer = setTimeout(() => {
                vm.closing = false
                vm.isYoutubeVideo = false
                vm.closeTimer = null
            }, 350)
        },
        onInput(val) {
            if (!val) this.hide()
        },
        loadVideo() {
            const vm = this
            if (vm.isYoutubeVideo) {
                vm.youtubeUrl = { videoId: vm.video }
            } else {
                vm.loadOptions()
            }
        },
        loadOptions() {
            const vm = this
            vm.playerOptions.poster = vm.thumb
            vm.playerOptions.sources[0].src = vm.video
            vm.playerOptions.sources[0].type = vm.videoType
            if (vm.$refs.videoPlayer && vm.$refs.videoPlayer.player) {
                vm.$refs.videoPlayer.player.pause();
                vm.$refs.videoPlayer.player.poster(vm.thumb)
                vm.$refs.videoPlayer.player.src({
                    type: vm.videoType,
                    src: vm.video,
                })
            }
        },
    },
    watch: {
        thumb(val) {
            if (val) this.loadVideo()
        },
        video(val) {
            if (val) this.loadVideo()
        },
    }
}

</script>

<style scoped>
/* Caja 16:9 fija: el video se muestra completo (contain), sin recortar */
.video-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
}

.video-wrap >>> #player,
.video-wrap >>> .youtube-thumb,
.video-wrap >>> .video-js {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    max-height: none !important;
    border-radius: 8px;
}

.video-wrap >>> .vjs-tech,
.video-wrap >>> .vjs-poster {
    object-fit: contain;
    background-size: contain;
}

.video-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.video-comment {
    margin-top: 16px;
    font-size: 13px;
    line-height: 1.5;
    color: var(--v-txtSecondary-base);
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-left: 3px solid var(--v-accent-base);
    border-radius: 0 8px 8px 0;
    padding: 10px 12px;
}

.video-comment b {
    color: var(--v-txtPrimary-base);
}
</style>
